import style from './thinking-indicator.module.css';

export const ThinkingIndicator = () => (
  <svg className={style.indicator} fill='none' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'>
    <circle className={style.dot1} cx='14' cy='13' r='2' />
    <circle className={style.dot2} cx='6' cy='13' r='2' />
    <circle className={style.dot3} cx='10' cy='8' r='2' />
  </svg>
);
